export default __webpack_public_path__ + "static/media/vc.1474ccf5.svg";